import React from 'react';
import classNames from 'classnames';
import LoginScreen from '../../components/login-screen';
import { XSmall } from '../../components/icons/x-small';
import BackButton from '../back-button';
import forMobileOnly from '../../hoc/for-mobile-only';
import styles from './login-page.scss';

const BackButtonMobile = forMobileOnly(BackButton);

const LoginPage = () => (
  <LoginScreen>
    <BackButtonMobile className={classNames(styles.closeButton, 'forum-icon-fill')}>
      <XSmall />
    </BackButtonMobile>
  </LoginScreen>
);

export default LoginPage;
